import { useMemo } from "react";
import { Tooltip } from "react-bootstrap";

export const useValidation = ({
  value,
  charMax,
  charMin,
}: {
  value: string;
  charMin?: number;
  charMax?: number;
}) => {
  // validations
  const hasValidation =
    typeof charMax !== "undefined" || typeof charMin !== "undefined";
  const isInRange =
    (value?.length || 0) >= (charMin || Number.MIN_SAFE_INTEGER) &&
    (value?.length || 0) <= (charMax || Number.MIN_SAFE_INTEGER);
  const isInvalid = !!value && !isInRange;
  const isValid = !value || isInRange;
  const validationTooltip = useMemo(() => {
    if (!hasValidation) return null;

    return (
      <Tooltip>
        {typeof charMin !== "undefined" ? (
          <div>Min: {charMin} characters</div>
        ) : null}
        {typeof charMax !== "undefined" ? (
          <div>Max: {charMax} characters</div>
        ) : null}
      </Tooltip>
    );
  }, [charMax, charMin, hasValidation]);

  return { isValid, isInvalid, validationTooltip };
};
